<section class="flex items-center justify-center min-h-screen">
  <div
    class="flex flex-col p-10 items-center bg-white shadow-lg rounded-lg w-[27rem] containerLogin"
  >
    <div class="w-full">
      <p class="text-[0.9rem] text-black mb-4">
        È necessario reimpostare la password.<br />
        Questa è la tua prima connessione e stai <br />
        utilizzando una password temporanea. <br />
        Inserisci una nuova password per continuare.
      </p>
      <label for="newPassword" class="block text-dimot-1 mb-2 text-[0.8rem]"
        >Inserisci la tua nuova password:</label
      >
      <div class="relative w-full">
        <input
          [type]="passwordFieldType"
          [(ngModel)]="newPassword"
          (focus)="showTooltip = true"
          (blur)="showTooltip = false"
          (input)="validatePassword()"
          id="newPassword"
          class="w-full text-gray-900 text-sm mx-auto block border border-gray-300 bg-[#cecece2c] p-3 rounded-lg mt-1"
        />
        <!-- Bottone per togglare la visibilità della password -->
        <button
          type="button"
          (click)="togglePasswordVisibility()"
          class="absolute inset-y-0 right-0 flex items-center z-20 px-3 cursor-pointer text-gray-400 rounded-e-md focus:outline-hidden focus:text-blue-600 dark:text-neutral-600 dark:focus:text-blue-500"
        >
          <!-- Occhio aperto -->
          <svg
            *ngIf="passwordFieldType === 'password'"
            class="w-6 h-6 text-gray-400 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-width="2"
              d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z"
            />
            <path
              stroke="currentColor"
              stroke-width="2"
              d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
          </svg>

          <!-- Occhio chiuso -->
          <svg
            *ngIf="passwordFieldType === 'text'"
            class="w-6 h-6 text-gray-400 dark:text-white"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            fill="none"
            viewBox="0 0 24 24"
          >
            <path
              stroke="currentColor"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
            />
          </svg>
        </button>
        <!-- Password Requirements Tooltip -->
        <div
          *ngIf="showTooltip"
          class="tooltip-password border border-gray-200 rounded-[8px] p-2 bg-gray-50 absolute text-[0.8rem]"
          style="
            bottom: 100%;
            left: 0;
            margin-bottom: 10px;
            width: 100%;
            z-index: 1000;
          "
        >
          <div
            class="tooltip-arrow shadow"
            data-popper-arrow
            style="
              position: absolute;
              bottom: 4px;
              width: 0;
              height: 0;
              z-index: 1 !important;
              border-left: 6px solid #e5e7eb !important;
              border-right: 6px solid #e5e7eb !important;
              border-top: 6px solid #f9fafb; /* match the tooltip border */
            "
          ></div>
          <span class="font-bold text-black">Requisiti:</span>
          <ul class="mb-0 pl-3">
            <li [class.text-success]="passwordValidations.minLength">
              <i
                [class]="
                  passwordValidations.minLength
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Minimo 8 caratteri
            </li>
            <li [class.text-success]="passwordValidations.number">
              <i
                [class]="
                  passwordValidations.number
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Almeno un numero
            </li>
            <li [class.text-success]="passwordValidations.lowercase">
              <i
                [class]="
                  passwordValidations.lowercase
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Almeno una lettera minuscola
            </li>
            <li [class.text-success]="passwordValidations.uppercase">
              <i
                [class]="
                  passwordValidations.uppercase
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Almeno una lettera maiuscola
            </li>
            <li [class.text-success]="passwordValidations.specialChar">
              <i
                [class]="
                  passwordValidations.specialChar
                    ? 'fa-solid fa-circle-check text-success me-1'
                    : 'fa-solid fa-circle-minus text-secondary me-1'
                "
              ></i>
              Almeno un carattere speciale
              <small class="ms-1 text-muted">(+, #, $, %, *, ., !, -)</small>
            </li>
          </ul>
        </div>
      </div>
      <button
        class="w-full h-12 bg-[#07ad9f] text-white text-[0.75em] p-3 rounded-lg mt-8 hover:bg-[#09c6b6] transition mx-auto block cursor-pointer"
        (click)="onResetPassword()"
      >
        REIMPOSTA PASSWORD
      </button>
    </div>

    <!-- Error Message -->
    <div *ngIf="errorMessage" class="alert alert-danger mt-3">
      {{ errorMessage }}
    </div>
  </div>
</section>
